import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { API } from "../../config";
import AuthFormContainer from "../../components/AuthFormContainer/AuthFormContainer";
import Button from "../../components/Button/Button";
import Input from "../../components/Input/Input";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const resetPassword = () => {
    const urlParams = new URLSearchParams(window.location.search);
    setLoading(true);
    axios
      .patch(`${API}/reset-password/${urlParams.get("token")}`, {
        password: password,
        confirmPassword: confirmPassword,
      })
      .then((response) => {
        setLoading(false);
        console.log(response);
        swal(
          "Reset success!",
          "You will now redirect to the App page!",
          "success",
          {
            button: "Okay",
          }
        );
        // .then(() => {
        //   history.push("/app");
        // });
      })
      .catch((err) => {
        setLoading(false);
        swal("Error!", `${err.response.data.message}`, "error", {
          button: "Okay",
        });
      });
  };
  return (
    <AuthFormContainer
      form={
        <>
          <Input
            type={"password"}
            p={"Please enter your password"}
            setFn={setPassword}
          />
          <Input
            type={"password"}
            p={"Please re-enter your password"}
            setFn={setConfirmPassword}
          />
          <Button
            text={"Reset Password"}
            clickFn={resetPassword}
            loader={loading}
          />
        </>
      }
    />
  );
};

export default ResetPassword;
